<template>
  <list-view-filters :list-view="listView"></list-view-filters>
</template>

<script lang="ts">
  import Vue from "vue";
  import ListViewFilters from "./list-view-filters.vue";
  import ListView from "../../../common/models/listViews/listView";
  import PublishedListView from "../../../common/models/listViews/publishedListView";

  export default Vue.extend({
    components: {
      ListViewFilters,
    },
    props: {
      listView: {
        type: Object as () => ListView | PublishedListView
      }
    },
  });
</script>